import DashboardLayout from "../../layouts/dashboard/DashboardLayout";
import Payments from "./views/Payments";
import Auth from "../../router/middleware/Auth";

export default [
  {
    path: "/payments",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Payments",
        components: { view: Payments },
        meta: { middleware: [Auth], breadcrumb: "Dashboard" },
      },
    ],
  },
];
